import { createInfiniteQuery } from '@amzn/gsce-shared-react-lib';
import {
  SearchAuditsCommand,
  type SearchAuditsCommandInput,
  type SearchAuditsCommandOutput,
} from '@amzn/gbsa-helios-typescript-client';
import { apiHeliosClient, withRetry } from '../../../shared/data';
import { AuditQueryKeys } from './keys';

/**
 * Infinite query hook for searching audits with cursor pagination.
 *
 * Built with createInfiniteQuery from the shared lib — same
 * [collectionName, filters] cache key shape as createQuery, so the key
 * is automatically scoped to the request params.
 *
 * Callers gate execution via options, e.g.
 * `useSearchAuditsQuery(input, { enabled: !!input.businessUnitId })`.
 */
export const useSearchAuditsQuery = createInfiniteQuery<
  SearchAuditsCommandInput,
  SearchAuditsCommandOutput,
  string | undefined
>(
  AuditQueryKeys.lists,
  (input, pageParam) =>
    withRetry(() =>
      apiHeliosClient.send(new SearchAuditsCommand({ ...input, nextToken: pageParam })),
    ),
  {
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => lastPage.nextToken ?? undefined,
  },
);
